<template>
    <s-modal
            :open="open"
            :close="true"
            @close="$emit('close')"
            :title="'Terrain de la rencontre : '+labelEquipe(equipe)"
        >
            <div  v-if="equipe.terrain!=null">
                La rencontre {{labelEquipe(equipe)}} se joue sur le terrain {{equipe.terrain.name}}
            </div>
            <div v-if="equipe.terrain==null">
                La rencontre {{labelEquipe(equipe)}} n'a pas encore de terrain
            </div>
            <s-button v-if="equipe.terrain!=null" @onclick="libereTerrain(equipe)" 
                :label="'Libérer '+equipe.terrain.name"
                theme="is-danger"/> &nbsp;&nbsp;
            <s-button @onclick="openLegend=true" label="Légende" theme="is-info"/>
                <br/><br/>
            <b>Affecter un nouveau terrain : </b>
            <div class="tableauTerrain">
                    <div v-for="terrain in allTerrains">
                         <button-terrain
                            v-if="zones!=null"
                            :zones="zones"
                            :terrain="terrain.name"
                            :zone="terrain.zone"
                            :indexPartie="indexPartie"
                            :parties="parties"
                            @onclick="affectTerrain(terrain.name, terrain.zone)"
                            :role="role"
                            :showDispo="true"
                            :equipe="equipe"
                        />
                    </div>
                
            </div>
            <s-info 
                :open="openLegend"
                :close="true"
                @close="openLegend=false"
                 :big="true">
                <b>Légende :</b>
                <div class="legendeTerrain">
                     <div>
                        <s-button theme="" label="" icon="exclamation" /> Terrain occupé sur plusieurs parties en cours
                    </div>
                   <div>
                        <s-button theme="" label="" icon="street-view" /> Un des joueurs a déjà joué sur ce terrain
                    </div>
                    <div>
                        <s-button theme="is-small" label="Terrain X" width="20px"/> Terrain disponible
                    </div>
                    <div>
                        <s-button theme="is-warning is-small" label="Terrain X" width="20px"/> Terrain affecté à un jeu terminé
                    </div>
                    <div>
                        <s-button theme="is-dark  is-small" label="Terrain X" width="20px"/> Terrain occupé dans cette partie
                    </div>
                     <div>
                        <s-button theme="is-danger  is-small" label="Terrain X" width="20px"/> Terrain non disponible par le club
                    </div>
                   
                </div>
            </s-info>
        </s-modal>
</template>
<style scoped>
    .legendeTerrain div {
        margin-bottom: 5px;
        vertical-align: top;
    }
    .tableauTerrain {
        overflow-y: auto;
        width: 100%;
        height: 300px;
        border: thin solid black;
    }
    .tableauTerrain div {
        display: inline-block;
        margin: 10px;
    }
    .terrain {
        background-color: gray;
        color: white;
        margin-bottom: 2px;
        border-radius: 10px;
    }
</style>
<script>
import terrain_object from '@/firebase/terrain.js'
import ButtonTerrain from '@/views/tournoi/inProgress/buttonTerrain.vue'
export default ({
   props: ["open", "equipe", "equipes", "tournoi", "club", "indexPartie", "role", "parties"],
   components: {
           ButtonTerrain
       },
    data() {
        return {
            openLegend:false
        }
    },
   computed: {
       
       zones: {
            get() {
                return this.tournoi.options.zones;
            }
        },
       allTerrains: {
            get() {
                var allTerrains=[];
                for (var zone in this.zones) {
                    for (var terrain in this.zones[zone].terrains) {
                        var terrainNode = JSON.parse(JSON.stringify(this.zones[zone].terrains[terrain]));
                        terrainNode.name = terrain;
                        terrainNode.zone = zone;
                        allTerrains.push(terrainNode);
                    }
                }
               
                allTerrains.sort((a,b)=>{
                    return a.zone.localeCompare(b.zone) || a.numero - b.numero
                })
               
                return allTerrains;
            }
        },
   },
   methods: {
       labelEquipe(equipe) {
              if (equipe!=null) {
              var joueurs = "";
              if (equipe.joueurs.J1 != null)
                joueurs += (equipe.joueurs.J1.numero+1);
              if (equipe.joueurs.J2 != null)
                joueurs += " - " + (equipe.joueurs.J2.numero+1);
              if (equipe.joueurs.J3 != null)
                joueurs += " - " + (equipe.joueurs.J3.numero+1);
             var contre = "";
              if (equipe.contre.J1 != null)
                contre += (equipe.contre.J1.numero+1);
              if (equipe.contre.J2 != null)
                contre += " - " + (equipe.contre.J2.numero+1);
              if (equipe.contre.J3 != null)
                contre += " - " + (equipe.contre.J3.numero+1);
              return  joueurs + " vs " + contre;
                }
                else
                    return "";
          },
       affectTerrain(terrainKey, zone) {
               
                var indexEquipe = this.equipes.findIndex(equipe=>{
                    if (equipe.terrain==null)
                        return false;
                    else
                        return equipe.terrain.name===terrainKey;
                });
                if (indexEquipe!=-1) {
                    var id = this.equipes[indexEquipe].id;
                    var equipeASupTerrain = JSON.parse(JSON.stringify(this.equipes[indexEquipe]));
                    equipeASupTerrain.id = id;
                    
                    this.libereTerrain(equipeASupTerrain);
                }
                
                var terrainEquipe = {
                        name: terrainKey,
                        zone: zone
                }
                this.$emit("setTerrainEquipe", this.equipe, terrainEquipe)
       },
       libereTerrain(equipe) {
                if (equipe.terrain!=null)
                    terrain_object.object.setTerrain(this.zones, this.club, this.tournoi, this.indexPartie, equipe.terrain.name, equipe.terrain.zone, "EMPTY", true);
                this.$emit("setTerrainEquipe", equipe, null);
        },
   }

   
})
</script>
